import { render } from "./AllSdaRemainder.vue?vue&type=template&id=70bae67b&scoped=true"
import script from "./AllSdaRemainder.vue?vue&type=script&lang=js"
export * from "./AllSdaRemainder.vue?vue&type=script&lang=js"

import "./AllSdaRemainder.vue?vue&type=style&index=0&id=70bae67b&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bae67b"]])

export default __exports__